import { Status, StatusProps } from '@insight-health-ai/roseate/components';
import { EncounterStatus as EncounterStatusType } from 'src/models';

type ExtendedEncounterInvisitStatus =
  | EncounterStatusType
  | 'clinical-note-generated';

const statusConfigMap: Record<
  ExtendedEncounterInvisitStatus,
  {
    appearance?: StatusProps['appearance'];
    label: string;
    style?: StatusProps['style'];
  }
> = {
  new: { appearance: 'info', label: 'Not Started' },
  inprogress: { appearance: 'warning', label: 'In Progress' },
  completed: { appearance: 'success', label: 'Completed' },
  summary_inprogress: { appearance: 'warning', label: 'Summary In Progress' },
  saved_to_ehr: { label: 'Saved to EHR', style: { color: '#4d38ca' } },
  'clinical-note-generated': {
    appearance: 'success',
    label: 'Clinical Note Generated',
  },
};

type EncounterInvisitStatusProps = {
  status: ExtendedEncounterInvisitStatus;
  statusProps?: StatusProps;
};

export const EncounterStatus = ({
  status,
  statusProps,
}: EncounterInvisitStatusProps) => {
  const config = statusConfigMap[status];

  return (
    <Status
      size="sm"
      {...statusProps}
      style={config?.style}
      appearance={config?.appearance || 'neutral'}
      label={config?.label || status || 'Unknown'}
    />
  );
};
